import { Fragment, useEffect, useRef, useState } from "react";

export let serverUrl = localStorage.getItem("ServerUrl");
export function setServerUrl(url)
{
    serverUrl = url;
}

export function getheader() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    myHeaders.append('token', localStorage.getItem('token'))
    window._header = myHeaders;
    return myHeaders;
}
export const invoiceTypes = {
    PrePurchase: "PrePurchase",
    Purchase: "Purchase",
    PreSale: "PreSale",
    Sale: "Sale",
    Borrow: "Borrow",
    Resid: "Resid",
    OutOfOrder: "OutOfOrder",
    ReturnFromPurchase: "ReturnFromPurchase",
    ReturnFromSale: "ReturnFromSale",
    ReturnFromBorrow: "ReturnFromBorrow",
    Transfer: "Transfer"
}
export const invoiceTypesArray = [
    { TypeName: invoiceTypes.Transfer, TypeStr: "انتقال بین انبارها" },
    { TypeName: invoiceTypes.ReturnFromPurchase, TypeStr: "برگشت از خرید" },
    { TypeName: invoiceTypes.ReturnFromSale, TypeStr: "برگشت از فروش" },
    { TypeName: invoiceTypes.ReturnFromBorrow, TypeStr: "برگشت حواله به نماینده" },
    { TypeName: invoiceTypes.PrePurchase, TypeStr: "پیش فاکتور خرید" },
    { TypeName: invoiceTypes.PreSale, TypeStr: "پیش فاکتور فروش" },
    { TypeName: invoiceTypes.OutOfOrder, TypeStr: "حواله انبار" },
    { TypeName: invoiceTypes.Borrow, TypeStr: "حواله به نماینده" },
    { TypeName: invoiceTypes.Resid, TypeStr: "رسید انبار" },
    { TypeName: invoiceTypes.Purchase, TypeStr: "فاکتور خرید" },
    { TypeName: invoiceTypes.Sale, TypeStr: "فاکتور فروش" }

];

export function translateError(message) {
    message = message.toLowerCase();
    if (message.includes("no http resource was found")) {
        return "تابع سمت سرور یافت نشد";
    }
    switch (message) {
        case "productnotfound":
            return "کالایی با این مشخصات یافت نشد";
        case "fillsearchfields":
            return "کادرهای جستجو پر نشده است";
        case "no access":
            return "دسترسی مجاز نیست!‏";
        case "duplicateserial":
            return "سریال وارد شده تکراری است یا کار تکمیل نشده ای برای این سریال وجود دارد";
        case "errormobile":
            return "کاربری با این شماره همراه در سیستم وجود دارد";
        case "errorphone":
            return "کاربری با این شماره تلقن در سیستم وجود دارد";
        case "errornationalcode":
            return "کابری با این شماره ملی در سیستم وجود دارد";
        case "success":
            return "عملیات با موفقیت انجام شد";
        case "failed to fetch":
            return "ارتباط با سرور برقرار نیست";
        case "":
        case "error":
        case undefined:
            return "اشکال در انجام عملیات";
        default:
            return message;
    }
}
export function setErrorDialog(dispatch, message, title) {
    let dialogData = {
        status: 'show',
        arrayBtn: ['ok'],
        dialogTitle: '',
        dialogText: ' '
    };
    dialogData.dialogTitle = title;
    message = message.toLowerCase();
    switch (message) {
        case "productnotfound":
            dialogData.dialogText = "کالایی با این مشخصات یافت نشد";
            break;
        case "fillsearchfields":
            dialogData.dialogText = "کادرهای جستجو پر نشده است";
            break;
        case "no access":
            dialogData.dialogText = "دسترسی مجاز نیست!‏";
            break;
        case "duplicateserial":
            dialogData.dialogText = "سریال وارد شده تکراری است یا کار تکمیل نشده ای برای این سریال وجود دارد";
            break;
        case "errormobile":
            dialogData.dialogText = "کاربری با این شماره همراه در سیستم وجود دارد";
            break;
        case "errorphone":
            dialogData.dialogText = "کاربری با این شماره تلقن در سیستم وجود دارد";
            break;
        case "errornationalcode":
            dialogData.dialogText = "کابری با این شماره ملی در سیستم وجود دارد";
            break;
        case "success":
            dialogData.dialogText = "عملیات با موفقیت انجام شد";
            break;
        case "failed to fetch":
            dialogData.dialogText = "ارتباط با سرور برقرار نیست";
            break;
        case "":
        case "error":
        case undefined:
            dialogData.dialogText = "اشکال در انجام عملیات";
            break;
        default:
            dialogData.dialogText = message;

    }
    dispatch({
        type: "SET_DIALOG",
        data: dialogData
    });
}
export function ListenToEventSource(onMessage) {
    const register = (systemID) => {
        if (window.EventSource) {
            const source = new EventSource(serverUrl + `api/ServerEventsAPI/SubscribeToListener?SystemID=${systemID}`, {
                //withCredentials: true
            });
            source.onmessage = (e) => {
                onMessage(e.data);

            };
            source.onerror = (err) => {
                console.log(err);
            }
        }
    }
    const systemID = localStorage.getItem("SystemID");
    const token = localStorage.getItem("token");
    if (!systemID && token) {
        fetch(serverUrl + "api/ServerEventsAPI/GetSystemID?customer=true", {
            headers: getheader()
        }).then(res => res.json())
            .then(res => {
                if (!res.ID) {
                    console.log("GET_SYSTEM_ID", "Error");
                    return;
                }
                localStorage.setItem("SystemID", res.ID);
                register(res.ID);
            })
    }
    else if (token) {
        register(systemID);
    }

}
function checkNotificationPromise() {
    try {
        Notification.requestPermission().then();
    } catch (e) {
        return false;
    }

    return true;
}
export function askNotificationPermission() {
    // function to actually ask the permissions
    function handlePermission(permission) {
        // set the button to shown or hidden, depending on what the user answers
        //notificationBtn.style.display =
        // Notification.permission === 'granted' ? 'none' : 'block';
    }

    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
        console.log("This browser does not support notifications.");
    } else if (checkNotificationPromise()) {
        Notification.requestPermission().then((permission) => {
            handlePermission(permission);
        });
    } else {
        Notification.requestPermission((permission) => {
            handlePermission(permission);
        });
    }
}
export function savePrintReport(reportName, reportJSON) {
    fetch(serverUrl + "api/PrintReportAPI/SaveReport/" + reportName, {
        headers: getheader(),
        body: JSON.stringify(reportJSON),
        method: "POST"
    }).then(res => res.json())
        .then(res => {
            if (res === "success")
                alert("فایل چاپ با موفقیت ذخیره شد");
            else {
                alert("اشکال در ذخیره فایل چاپ");
            }
        })
}
export function loadPrintReport(reportName, fn) {
    fetch(serverUrl + "api/PrintReportAPI/LoadReport?reportName=" + reportName, {
        headers: getheader(),
        method: "GET"
    }).then(res => res.json())
        .then(res => {
            if (!res.Message) {
                fn(res);
            }
        })
}
export function loadPrintDataSource_get(url, fn) {
    return dispatch => {
        fetch(serverUrl + url, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "چاپ فرم");
                }
                else {
                    fn(res);
                }
            }).catch(e => console.log("[LOAD_PRINT_DATASOURCE_GET", e.Message));
    }
}
export function loadPrintDataSource_post(url, data, fn) {
    return dispatch => {
        fetch(serverUrl + url, {
            headers: getheader(),
            method: "POST",
            body: data
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "چاپ فرم");
                    console.log("[LOAD_PRINT_DATASOURCE_GET", res.Message);
                }
                else {
                    fn(res);
                }
            }).catch(e => console.log("[LOAD_PRINT_DATASOURCE_GET", e.Message));
    }
}
export function getRemainedAccount(accountID, accountCat, onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + `api/DocumentsAPI/GetRemainedAccount?accountID=${accountID}&accountCat=${accountCat}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = -1;
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_REMAINED_ACCOUNT]", e);
            onGetData(-1);
        })
}
export function getImageServerPath(imageFullName, onGetData) {
    fetch(serverUrl + `api/Attachments/GetImageServerPath?imageFullName=${imageFullName}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            onGetData(res);
        }).catch(e => {
            console.log("[GET_REMAINED_ACCOUNT]", e);
            onGetData(-1);
        })
}

export default function FindLinkInText(props) {

    const [isLink, setIsLink] = useState(props.text.includes("http"))
    const [textArr, setTextArr] = useState([])

    useEffect(() => {
        const txt = props.text
        if (txt.includes("http")) {
            setIsLink(true)
            const firstIndex = txt.indexOf("http"); //find link start 
            let linkEnd = txt.indexOf(" ", firstIndex) //find the end of link
            if (linkEnd === -1) {
                linkEnd = txt.length;
            }
            const firstTextSection = txt.slice(0, firstIndex)
            const linkSection = txt.slice(firstIndex, linkEnd)
            const secondSection = txt.slice(linkEnd)
            setTextArr([firstTextSection, linkSection, secondSection])
        } else {
            setIsLink(false)
        }
    }, [])
    return isLink ? (
        <Fragment >
            {textArr[0]}
            <a href={textArr[1]} target="_blank" rel="noopener noreferrer">{textArr[1]}</a>
            {textArr[2]}
        </Fragment>
    ) : (
        <div>
            <p>{props.text}</p>
        </div>)
}
export function isMobileApp(){
    return (window.innerWidth <= 414 || (window.innerHeight < 540));
}
export function isWebApp(){
    return (window.innerWidth > 414 && window.innerHeight >= 540 );
}
export function checkNationalCode (NationalCode) {
    if (NationalCode.length == 10) {
        if (NationalCode == '1111111111' ||
            NationalCode == '0000000000' ||
            NationalCode == '2222222222' ||
            NationalCode == '3333333333' ||
            NationalCode == '4444444444' ||
            NationalCode == '5555555555' ||
            NationalCode == '6666666666' ||
            NationalCode == '7777777777' ||
            NationalCode == '8888888888' ||
            NationalCode == '9999999999') {
            return false;
        }
        let c = parseInt(NationalCode.charAt(9));
        let n = parseInt(NationalCode.charAt(0)) * 10 +
            parseInt(NationalCode.charAt(1)) * 9 +
            parseInt(NationalCode.charAt(2)) * 8 +
            parseInt(NationalCode.charAt(3)) * 7 +
            parseInt(NationalCode.charAt(4)) * 6 +
            parseInt(NationalCode.charAt(5)) * 5 +
            parseInt(NationalCode.charAt(6)) * 4 +
            parseInt(NationalCode.charAt(7)) * 3 +
            parseInt(NationalCode.charAt(8)) * 2;
        let r = n - parseInt(n / 11) * 11;
        if (!((r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r))) {
            return false;
        }
        else {
            return true;
        }
    }
    else if (NationalCode !=='') {
        return false;
    }
    return true;

}
export function check_phone (number) {
    var regex = new RegExp("^(\\+98|0)?9\\d{9}$");
    var result = regex.test(number);
    return result;
  };
  export function createCaptcha(captchaEl) {
    captchaEl.innerHTML = "";
    var charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var lengthOtp = 6;
    var captcha = [];
    for (var i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    var canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 120;
    canv.height = 50;
    var ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    const code = captcha.join("");
    captchaEl.appendChild(canv);
    return code.toLocaleLowerCase();
  }